import { defineStore } from 'pinia';

export const useStore = defineStore({
  id: 'auth',

  state: () => {
    return {
      sapCustomerId: '',
      isTokValid: true,
      tok: '',
    };
  },

  actions: {
    setSapCustomerId(id: string) {
      this.sapCustomerId = id;
    },
    setTok(token: string) {
      this.tok = token;
    },
    setIsTokValid(isTokenValid: boolean) {
      this.isTokValid = isTokenValid;
    },
  },
});
